import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import i18n from 'i18next';
import { connect } from 'react-redux';
import { config } from '../config';
// import loader from '../images/loader.svg';
import { Link } from 'react-router-dom';
// import defImage from '../images/not-image.png';
import defImage from '../images/no_image.png';
import favIcon from '../images/fav_icon.svg';
import compareIcon from '../images/compare_icon.svg';
import { getsHistoryItems } from '../actions/itemHistory';
import {
  addToCart,
  addToWish,
  removeFromWish,
  addToCompare,
  removeFromCompare,
  changeComment,
} from '../actions/wishCompareCart';

class PrHistory extends Component {
  constructor(props) {
    super(props);
    // this.state = {
    //   count: 0,
    // };
  }

  componentDidMount() {
    // fetch some data using an action creator passed as a prop
    const currentId = this.props.productId;
    console.log('this.props', this.props.productId);
    let historyIds = [];
    let historyIdsStr = localStorage.getItem('historyIds');
    if (!historyIdsStr) {
      historyIds = [currentId];
    } else {
      historyIds = historyIdsStr.split(',').map(Number);
      let index = historyIds.findIndex((elem) => elem === currentId);
      if (index !== -1) {
        historyIds.splice(index, 1);
      }
      historyIds.splice(10);
      historyIds.unshift(currentId);
      let historyIdsWO = [...historyIds];
      historyIdsWO.splice(0,1);
      this.props.getHistoryItems(historyIdsWO);
    }
    localStorage.setItem('historyIds', historyIds);
  }

  render() {
    const { t } = this.props;
    // const dummyProductsArray = [
    //   {
    //     prodname: 'prodname1',
    //     name: 'product name1',
    //     price: 10.0,
    //     priceOld: 12.0,
    //   },
    //   {
    //     prodname: 'prodname2',
    //     name: 'product name2',
    //     price: 51.0,
    //     priceOld: 52.0,
    //   },
    // ];
    // console.log(
    //   'this.props.historyItems',
    //   this.props.historyItems.historyItems
    // );
    return (
      <div class='uk-section'>
        <div class='products-viewed-title uk-heading-line uk-text-center'>
          <span>{t('products.viewed')}</span>
        </div>
        <div className='uk-slider-container-offset' uk-slider={''}>
          <div
            className='uk-position-relative uk-visible-toggle uk-light uk-padding-small uk-padding-remove-horizontal'
            tabindex='-1'
          >
            <ul className='uk-slider-items uk-child-width-1-2 uk-child-width-1-3@m uk-child-width-1-4@l uk-grid'>
              {this.props.historyItems &&
                this.props.historyItems.historyItems &&
                this.props.historyItems.historyItems.length &&
                this.props.historyItems.historyItems.map((cProduct) => (
                  <li>
                    <div className='product-card uk-card uk-card-small'>
                      <div className='uk-card-media-top uk-text-center uk-padding-small'>
                        <Link
                          to={`/products/${i18n.language}/${cProduct.category}/item/${cProduct.id}`}
                        >
                          <img
                            className='product-card__image uk-height-small'
                            src={
                              cProduct.mainImage
                                ? `${config.assetsPrfix}img/products/min_${cProduct.mainImage}`
                                : defImage
                            }
                            title={cProduct.nameProduct}
                            alt={cProduct.nameProduct}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = defImage;
                            }}
                          />
                        </Link>
                      </div>
                      <div className='uk-card-body'>
                      
                        <Link
                          to={`/products/${i18n.language}/${cProduct.category}/item/${cProduct.id}`}
                          className='product-card__name'
                        >
                          <h3>{cProduct.nameProduct} </h3>
                        </Link>
                        <div className='product-card__price uk-flex uk-flex-between uk-flex-left@m'>
                          <span> {cProduct.price1 == 0.01 ? t('item.priceSpecify') : `${cProduct.price1} грн.`}</span>
                          {cProduct.price2 > cProduct.price1 && (
                            <span className='product-card__price-discount uk-margin-small-left'>
                              {cProduct.price2} грн
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="product-card__stock-label">{t(cProduct.stockInfo)}</div>
                      <div className='uk-card-footer'>
                        <div className='uk-flex uk-flex-middle uk-flex-between uk-flex-center@m uk-flex-wrap'>
                          <button 
                           onClick={(e) =>
                            this.props.addToCart(
                              cProduct.id
                            )
                          }
                          className={`product-card__addtocart-btn ${!cProduct.isInStock&&'product-card__addtocart-disable'} uk-width-1-1 uk-width-2-3@m uk-button uk-button-small uk-text-capitalize`} 
                          disabled={cProduct.isInStock?false:true}
                          >
                            {t('item.add_tocart')}
                          </button>
                          <div className='cart-footer-controls uk-flex uk-child-width-expand uk-width-1-3@m'>
                            <div 
                              className={
                                this.props.compareData.data !== undefined &&
                                this.props.compareData.data[
                                  cProduct.id
                                ] === undefined
                                  ? 'uk-text-center product-compare-btn__active'
                                  : 'uk-text-center product-compare-btn__inactive'
                              }
                              onClick={(e) => {
                                this.props.compareData.data[
                                  cProduct.id
                                ] === undefined
                                  ? this.props.addToCompare(
                                    cProduct.id
                                    )
                                  : this.props.removeFromCompare(
                                    cProduct.id
                                    );
                              }}
                              title={
                                this.props.compareData.data !== undefined &&
                                this.props.compareData.data[
                                  cProduct.id
                                ] === undefined
                                  ? t('item.add_tocompare')
                                  : t('item.removeToCompare')
                              }
                            >
                              <img
                                className='product-card__footer-btn_img product-block__control-icon'
                                src={compareIcon}
                                alt={''}
                                uk-svg={''}
                              />
                            </div>
                            <div 
                              className={
                                this.props.wishData.data !== undefined &&
                                this.props.wishData.data[
                                  cProduct.id
                                ] === undefined
                                  ? 'uk-text-center product-wish-btn__active'
                                  : 'uk-text-center product-wish-btn__inactive'
                              }
                                                          
                              onClick={(e) => {
                                this.props.wishData.data[
                                  cProduct.id
                                ] === undefined
                                  ? this.props.addToWish(
                                    cProduct.id
                                    )
                                  : this.props.removeFromWish(
                                    cProduct.id
                                    );
                                }}
                              title={
                                this.props.wishData.data !== undefined &&
                                this.props.wishData.data[
                                  cProduct.id
                                ] === undefined
                                  ? t('item.add_towish')
                                  : t('item.removeToFavorite')
                              }
                              >
                              <img
                                className='product-card__footer-btn_img product-block__control-icon'
                                src={favIcon}
                                alt={''} 
                                uk-svg={''}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
            </ul>
            <a
              className='uk-position-center-left uk-position-small uk-hidden-hover'
              href='#'
              uk-slidenav-previous={''}
              uk-slider-item='previous'
            ></a>
            <a
              className='uk-position-center-right uk-position-small uk-hidden-hover'
              href='#'
              uk-slidenav-next={''}
              uk-slider-item='next'
            ></a>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  console.log('mapStateToProps->state.historyItems', state.historyItems);
  const {
    wishData,
    compareData,
    isShowCompareCartWishLoader
  } = state.wishCompareCart;
  return {
    historyItems: state.historyItems,
    isShowCompareCartWishLoader,
    wishData,
    compareData
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (item) => {
      dispatch(addToCart(item));
    },
    getHistoryItems: (ids) => {
      dispatch(getsHistoryItems(ids));
    },
    addToWish: (item) => {
      dispatch(addToWish(item));
    },
    removeFromWish: (item) => {
      dispatch(removeFromWish(item));
    },
    removeFromCompare: (item) => {
      dispatch(removeFromCompare(item));
    },
    addToCompare: (item) => {
      dispatch(addToCompare(item));
    },
  };
};

const ProductsHistory = withTranslation('translations')(PrHistory);
export default connect(mapStateToProps, mapDispatchToProps)(ProductsHistory);
